import react from "react";

const useQueryParams = () => {
  
  const getQueryParam = (param: string): string | null => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
  };

  const setQueryParams = (params: { [key: string]: string }): void => {
    const searchParams = new URLSearchParams(window.location.search);
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    });
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };
  return { getQueryParam, setQueryParams };
};

export default useQueryParams;
